import { useMutation } from '@tanstack/vue-query'
import Organisation from '@/api/Dara/Organisation'
import { useInvalidateQueries as useInvalidateStudentQueries } from '@/composable/queries/Dara/students'
import { useAuthStore } from '@/stores/auth'
import { useInvalidateQueries as useInvalidateOrganisationResourceQueries } from '@/composable/queries/Dara/organisationResources'

interface OrganisationSummaryReportData {
  organisation_academic_year_id: number | 'all';
  programme_id: number;
  email_to_notify?: string;
  year_group_id?: null|number;
  sub_group_id?: null|number;
  student_ids?: number[];
}

export const useOrganisationSetDefaultPassword = (
  organisationId: number,
) => {
  return useMutation({
    mutationFn: async (defaultPassword: string) => {
      return await Organisation.setDefaultPassword(organisationId, { default_password: defaultPassword })
    },
  })
}

export const useOrganisationSetDefaultPasswordToExistingStudents = (
  organisationId: number,
) => {
  const { invalidateStudentsQuery  } = useInvalidateStudentQueries()

  return useMutation({
    mutationFn: () =>
      Organisation.setDefaultPasswordToExistingStudents(organisationId),

    onSuccess: invalidateStudentsQuery,
  })
}

export const useOrganisationRemoveDefaultPassword = (
  organisationId: number,
) => {
  const { invalidateStudentsQuery  } = useInvalidateStudentQueries()

  return useMutation({
    mutationFn: () => Organisation.removeDefaultPassword(organisationId),

    onSuccess: invalidateStudentsQuery,
  })
}

export const useOrganisationSaveSettings = () => {
  const authStore = useAuthStore()

  return useMutation({
    mutationFn: (formData: object) => Organisation.saveSettings(authStore.organisation?.id ? authStore.organisation?.id : 0, formData),

    onSuccess: () => {
      authStore.getLoggedInUser()
    },
  })
}

export const useGenerateOrganisationSummaryReport = () => {
  const authStore = useAuthStore()
  const { invalidateOrganisationResourceQuery } = useInvalidateOrganisationResourceQueries()

  return useMutation({
    mutationFn: (formData: OrganisationSummaryReportData) => Organisation.generateSummaryReport(authStore.organisation?.id ? authStore.organisation?.id : 0, formData),

    onSuccess: () => {
      invalidateOrganisationResourceQuery(authStore.organisation?.id ? authStore.organisation?.id : 0)
    },
  })
}
